






import { Component, Watch } from 'vue-property-decorator';
import TemplateMixin from '../TemplateMixin.vue';

/**
 * 自定义字段展示列表
 *
 * @author liyuyao
 * @date 03/12/2020
 */
@Component
export default class ComponentPermission extends TemplateMixin {
    permissionValue: boolean = false;

    @Watch('value', { immediate: true })
    initPermission() {
        this.permissionValue = this.value === 'private';
    }

    valueChange() {
        this.value = this.permissionValue ? 'private' : 'public';
        this.$emit('change', this.value, this.field);
    }
}
